<template>
    <div class="tags">
        <div v-if="title">
            <p class="tags__title">{{title}}</p>
        </div>
        <div class="tags__container">
            <div 
                v-for="(tag, index) in tags" 
                :key="`${tag}-${index}`"
                :class="{
                    'bordered': withBorder,
                    'colored': type === 'colored',
                    'default': type === 'default',
                }"
                class="tags__item-wrapper"
            >
                <p class="tags__item">
                    <span v-if="withHashTag">#</span>
                    {{tag}}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Tags',
    props: {
        tags: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: () => ''
        },
        type: {
            type: String,
            default: () => 'default' //default, colored, simple
        },
    },
    computed: {
        withHashTag() {
            return this.type === 'simple' || this.type === 'colored'
        },
        withBorder() {
            return this.type === 'default' || this.type === 'colored'
        }
    }
}
</script>

<style lang="scss" scoped>
$font_size: 14px;
$title_size: 24px;
$title_lineheight: 32px;
$line_height: 20px;
$color: #333333;
$tag_padding: 4px 8px;
$tag_margin: 0 8px 8px 0;
$space_16: 16px;
$radius: 8px;
$border: 1px solid #E2E8F0;
$default_tag_background: #e2e8f033;
.tags {
    p {
        margin-bottom: 0;
    }
    &__title {
        font-size: $title_size;
        line-height: $title_lineheight;
        font-weight: bold;
    }
    &__container {
        display: flex;
        flex-wrap: wrap;
        margin-top: 16px;
    }
    &__item {
        margin-bottom: 0;
        font-size: $font_size;
        color: $color;
        line-height: $line_height;
    }
    &__item-wrapper {
        margin: $tag_margin;
        &.bordered {
            padding: $tag_padding;
            border-radius: $radius;
        }
        &.default {
            border: $border;
            background: $default_tag_background;
        }
    }
}
</style>>
